import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    defaultMessage: 'Edit Blacklist Entry',
    description: 'Header for edit blacklist entry modal',
    id: 'yepUn5',
  },
  description: {
    defaultMessage: 'Update the reason for this blacklisted address.',
    description: 'Description text for edit blacklist entry modal',
    id: '4TUA1e',
  },
  addressLabel: {
    defaultMessage: 'Address',
    description: 'Label for the read-only address display',
    id: 'PZireI',
  },
  reasonLabel: {
    defaultMessage: 'Reason',
    description: 'Label for reason input',
    id: '75aLrv',
  },
  reasonPlaceholder: {
    defaultMessage: 'Why is this address blacklisted? (optional)',
    description: 'Placeholder for reason input',
    id: 'Df539+',
  },
  reasonMaxLengthError: {
    defaultMessage: 'Reason must be 500 characters or less.',
    description: 'Error message when reason exceeds maximum length',
    id: '82CQUM',
  },
  referenceOrderIdLabel: {
    defaultMessage: 'Reference Order ID',
    description: 'Label for read-only reference order ID display',
    id: '6d9AB7',
  },
  cancel: {
    defaultMessage: 'Cancel',
    description: 'Cancel button text',
    id: 'hHNj31',
  },
  save: {
    defaultMessage: 'Save Changes',
    description: 'Save button text',
    id: 'VzH8Gv',
  },
  saving: {
    defaultMessage: 'Saving...',
    description: 'Button text while save is in progress',
    id: 'wWsCxY',
  },
});
